module.exports = __webpack_public_path__ + "img/web-proxy-vs-vpn.a3451a1d.webp";